module.exports = __webpack_public_path__ + "img/clinking_beer_mugs.eadf4946.gif";